<template>
  <div v-show="tabs.length > 0">
    <v-tabs v-model="tab" fixed-tabs center-active show-arrows>
      <v-tab v-for="tab in tabs" :key="tab.route" :to="tab.route" flat>
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-divider></v-divider>
  </div>
</template>
<script>
export default {
  data: () => ({
    tabs: [],
    tab: 0,
  }),

  created() {
    this.checkTabs();
  },

  watch: {
    $route() {
      this.checkTabs();
    },
  },

  methods: {
    checkTabs() {
      const showCpa = true;

      if (
          this.$route.path.includes("/financial/commissions") &&
          showCpa
        ) {
          const suffix = "/dashboard/financial/commissions";

          this.tabs = [
            {
              name: "Revenue Share",
              route: `${suffix}/revenueShare`,
            },
            {
              name: "CPA",
              route: `${suffix}/cpa`,
            },
          ];
          this.tab = 0;
        } else {
          this.tabs = [];
      }
    },
  },
};
</script>